import { gql } from '@apollo/client';

export const GetMultifactorAuthStatus = gql`
  query GetMultifactorAuthStatus($immutableId: String!) {
    multifactorAuthStatus(immutableId: $immutableId) {
      totpInitialized
      canUseMultifactor
      isActive
      emailMfaInitialized
    }
  }
`;
